import { GridColumn, GridRow } from 'app/layouts/grid';
import { Button } from 'app/shared/button';
import { InfoBanner } from 'app/shared/info-banner';
import { DetailItem } from 'app/shared/info-section/item';
import { TextArea } from 'app/shared/input/textarea';
import { useAIChatService } from 'hooks/ai/chat';
import React, { useState } from 'react';
import { toast } from 'react-toastify';

export const CreateFreeformContact = ({ onClose = () => {} }) => {
  const { sendChat } = useAIChatService();
  const [contact_info, setContactInfo] = useState('');
  const [is_processing, setIsProcessing] = useState(false);

  const submit = async () => {
    if (!contact_info.trim()) {
      return toast.error('Please paste contact information before submitting.');
    }

    setIsProcessing(true);
    const result = await sendChat({
      data: {
        messages: [
          {
            role: 'user',
            content: `Create contacts:\n\n${contact_info}`
          }
        ],
        skip_confirmation: true
      }
    });

    setIsProcessing(false);
    if (!result) {
      return toast.error('Could not process request at this time. Please try again.');
    }

    toast.success(result.reply || 'Contacts successfully queued for creation!');
    setContactInfo('');
    onClose();
  };

  return (
    <div>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <InfoBanner message="You can paste up to 100 contacts at once." />
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Paste contact information">
            <TextArea
              rows={10}
              character_count={contact_info.length}
              character_limit={2000}
              show_counter
              value={contact_info}
              onInput={setContactInfo}
            />
          </DetailItem>
        </GridColumn>
      </GridRow>
      <GridRow num_of_columns={3}>
        <GridColumn span={2} />
        <GridColumn>
          <Button
            text="Create contacts"
            loading={is_processing}
            disabled={is_processing}
            onClick={submit}
          />
        </GridColumn>
      </GridRow>
    </div>
  );
};
